import { observer } from 'mobx-react-lite';
import styles from '@features/productPreview/sections/StickyBar/components/StickyBarLinks/StickyBarLinks.styles';
import StickyMobileSlider from '@features/productPreview/sections/StickyBar/components/StickyMobileSlider/StickyMobileSlider';
import StickyDesktopLinks from '@features/productPreview/sections/StickyBar/components/StickyDesktopLinks/StickyDesktopLinks';
type PropTypes = {
  stickyBarLinks: Array<string>;
  isDesktop: boolean;
};
const StickyBarLinks = ({
  stickyBarLinks,
  isDesktop
}: PropTypes) => <div sx={styles.stickyLinks}>
    {isDesktop ? <StickyDesktopLinks stickyBarLinks={stickyBarLinks} /> : <StickyMobileSlider stickyBarLinks={stickyBarLinks} />}
  </div>;
export default observer(StickyBarLinks);